import { GetProp, Modal, Upload, UploadFile, message } from "antd";
import { UploadProps } from "antd/lib";
import React, { useEffect, useState } from "react";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { RcFile } from "antd/es/upload";
import { updateTeamMemberImage } from "../../../network/teamMember";

type Props = {
  mediaUrl: string;
  teamMemberId: number;
};

export default function TeamMemberImg({ mediaUrl, teamMemberId }: Props) {
  const [previewImage, setPreviewImage] = useState<any>(null);

  const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader?.addEventListener("load", () => callback(reader.result as string));
    reader?.readAsDataURL(img);
  };

  useEffect(() => {
    setPreviewImage(mediaUrl);
  }, []);

  const handleChange: UploadProps["onChange"] = ({
    file,
    fileList: newFileList,
  }) => {
    console.log(file, "file4444444444444444444444");
    for (let i = 0; i < newFileList.length; i++) {
      if (newFileList[i]?.type?.includes("image")) {
        const fileSize = newFileList[i]?.size;

        if (fileSize !== undefined) {
          const isLt2M = fileSize / 1024 / 1024 < 2;
          if (!isLt2M) {
            newFileList.splice(i, 1);
          }
        }
      } else {
        newFileList.splice(i, 1);
        message.error("يجب عليك اختيار صورة");
        break;
      }
    }
    getBase64(file?.originFileObj as RcFile, (url: any) => {
      setPreviewImage(url);
    });
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  const handleUpload = async ({ file, onSuccess }: any) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const beforeUpload = (file: RcFile) => {
    // const isJpgOrPng = file.type === 'image/*' || file.type === 'image/png';
    // if (!isJpgOrPng) {
    //   message.error('You can only upload JPG/PNG file!');
    // }
    console.log(file, "1223333");
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      // message.error("Image must smaller than 2MB!");
      message.error("حجم الصورة  يجب ان يكون اقل من  2 ميجا بايت");
    }
    const body = new FormData();
    body.append("image", file);

    updateTeamMemberImage(teamMemberId, body)
      .then((res: any) => {
        // console.log(res, 'aswwwwwww');
        if (res?.response?.status === 422 || res?.response?.status === 500) {
          message.error(res?.response?.data?.message);
        } else {
          message.success("Team member image updated successfully");
        }
      })
      .catch((err: any) => {
        console.log(err);
      });

    // return isJpgOrPng && isLt2M;
    return isLt2M;
  };
  return (
    <div>
      <Upload
        accept="image/*"
        customRequest={handleUpload}
        onChange={handleChange}
        maxCount={1}
        beforeUpload={beforeUpload}
        showUploadList={false}
        listType="picture-circle"
        className="avatar-uploader-no-border"
      >
        {previewImage ? (
          <img
            src={previewImage}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              border: "2px dashed",
            }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    </div>
  );
}
